import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9.84661 15.827C12.4898 16.9399 15.9633 15.4553 17.8277 12.3221C19.8015 9.00473 19.224 5.09559 16.5378 3.59075C13.8516 2.0859 10.0739 3.5552 8.10003 6.87253C6.46409 9.62194 6.58071 12.7779 8.19791 14.6346L5 20.0091L6.76866 20.9999L9.84661 15.827ZM16.0828 11.3446C15.6839 12.015 15.2243 12.5553 14.7374 12.9779V5.04023C15.0248 5.09095 15.2876 5.18201 15.5151 5.3095C16.8903 6.07988 17.7197 8.5936 16.0828 11.3446ZM11.674 14.2006V5.84041C12.3522 5.3705 13.0605 5.10868 13.7163 5.02406V13.681C13.0152 14.0508 12.3053 14.2131 11.674 14.2006ZM10.6529 14.0009C10.5691 13.9665 10.4888 13.9278 10.4126 13.8851C9.0374 13.1147 8.20803 10.601 9.84489 7.85001C10.0934 7.43241 10.3654 7.0653 10.6529 6.74567V14.0009Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Tennis"
);
